export default __webpack_public_path__ + "static/media/Group502-Yono@2x.323131c6.png";